import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import "./headerFile.js";

// Import function styles
import "./styles/functions/styles.css";
import "./styles/functions/fontStyles.css";
import "./styles/functions/deletePrompt.css";

// Import header_footer styles
import "./styles/header_footer/navStyles.css";

// Import content styles
import "./styles/content/homeStyles.css";
import "./styles/content/loginStyles.css";
import "./styles/content/warningStyles.css";
import "./styles/content/loadingStyles.css";
import "./styles/content/userlistStyles.css";

// Import router
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);

document.title = process.env.REACT_APP_WEB_TITLE;
const metaDescription = document.querySelector("meta[name='" + process.env.REACT_APP_WEB_NAME + "']")
if (metaDescription)
{
  metaDescription.setAttribute("content", process.env.REACT_APP_WEB_CONTENT);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
